(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-aside"]) return;
  try {
    
  (function () {
    var fetching = null;
    var countFetching = null;
    var pageScrollLocked = false;
    var lockedScrollY = 0;
    var previousBodyOverflow = '';
    var previousBodyPosition = '';
    var previousBodyTop = '';
    var previousBodyWidth = '';
    var previousHtmlOverflow = '';

    function getOverlay() { return document.querySelector('[data-cart-overlay]'); }
    function getAside() { return document.querySelector('[data-cart-aside]'); }

    function lockPageScroll() {
      if (pageScrollLocked) return;

      lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      previousBodyOverflow = document.body.style.overflow;
      previousBodyPosition = document.body.style.position;
      previousBodyTop = document.body.style.top;
      previousBodyWidth = document.body.style.width;
      previousHtmlOverflow = document.documentElement.style.overflow;

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.width = '100%';
      pageScrollLocked = true;
    }

    function unlockPageScroll() {
      if (!pageScrollLocked) return;

      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
      document.body.style.position = previousBodyPosition;
      document.body.style.top = previousBodyTop;
      document.body.style.width = previousBodyWidth;
      window.scrollTo(0, lockedScrollY);
      pageScrollLocked = false;
    }

    function getRecentlyViewedProducts() {
      try {
        var stored = JSON.parse(window.sessionStorage.getItem('past-midnight:recent-products') || '[]');

        return Array.isArray(stored) ? stored : [];
      } catch (error) {
        return [];
      }
    }

    function buildRecentProductCard(product) {
      var card = document.createElement('div');
      card.className = 'cart-aside__recent-card';

      var imageButton = document.createElement('button');
      imageButton.className = 'cart-aside__recent-image-button';
      imageButton.type = 'button';
      imageButton.dataset.recentCartAdd = product.variantId || '';
      imageButton.dataset.recentProductUrl = product.url || '';
      imageButton.setAttribute('aria-label', 'Add ' + (product.title || 'product') + ' to cart');

      var imageWrap = document.createElement('span');
      imageWrap.className = 'cart-aside__recent-image-wrap';

      if (product.image) {
        var image = document.createElement('img');
        image.className = 'cart-aside__recent-image';
        image.src = product.image;
        image.alt = product.imageAlt || product.title || '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }

      var addIcon = document.createElement('span');
      addIcon.className = 'cart-aside__recent-add-icon';
      addIcon.setAttribute('aria-hidden', 'true');
      addIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" width="14" height="14"><path d="M12 5v14M5 12h14"/></svg>';

      var details = document.createElement('a');
      details.className = 'cart-aside__recent-details';
      details.href = product.url || '#';

      var title = document.createElement('span');
      title.className = 'cart-aside__recent-title';
      title.textContent = product.title || '';

      var price = document.createElement('span');
      price.className = 'cart-aside__recent-price';
      price.textContent = product.price || '';

      details.appendChild(title);
      details.appendChild(price);
      imageButton.appendChild(imageWrap);
      imageButton.appendChild(addIcon);
      card.appendChild(imageButton);
      card.appendChild(details);

      return card;
    }

    function getProductJsonUrl(url) {
      if (!url) return '';

      var cleanUrl = url.split('#')[0].split('?')[0].replace(/\/$/, '');
      return cleanUrl + '.js';
    }

    function resolveRecentVariantId(button) {
      var variantId = button.dataset.recentCartAdd;
      if (variantId) return Promise.resolve(parseInt(variantId, 10));

      var productJsonUrl = getProductJsonUrl(button.dataset.recentProductUrl || '');
      if (!productJsonUrl) return Promise.resolve(null);

      return fetch(productJsonUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Product lookup failed');
          return response.json();
        })
        .then(function (product) {
          var variants = product && Array.isArray(product.variants) ? product.variants : [];
          var variant = variants.find(function (candidate) {
            return candidate && candidate.available;
          }) || variants[0];

          return variant ? variant.id : null;
        })
        .catch(function () {
          return null;
        });
    }

    function initRecentlyViewedAddButtons() {
      document.querySelectorAll('[data-recent-cart-add]').forEach(function (button) {
        if (button.dataset.recentCartAddInitialized === 'true') return;
        button.dataset.recentCartAddInitialized = 'true';

        button.addEventListener('click', function () {
          if (button.disabled) return;

          button.disabled = true;

          resolveRecentVariantId(button)
            .then(function (variantId) {
              if (!variantId) throw new Error('Missing variant id');

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 }),
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart add failed');
              document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
            })
            .finally(function () {
              button.disabled = false;
            });
        });
      });
    }

    function renderRecentlyViewedContainer(container, products) {
      var row = container.querySelector('[data-cart-recently-viewed-row]');
      if (!container || !row) return;

      var body = container.previousElementSibling;
      var cartBody = body && body.classList.contains('cart-aside__body') ? body : null;

      row.innerHTML = '';

      if (!products.length) {
        container.classList.add('hidden');
        if (cartBody) cartBody.classList.remove('has-recent-fade');
        return;
      }

      products.forEach(function (product) {
        row.appendChild(buildRecentProductCard(product));
      });

      container.classList.remove('hidden');
      if (cartBody) cartBody.classList.add('has-recent-fade');
    }

    function renderRecentlyViewedProducts() {
      var products = getRecentlyViewedProducts().filter(function (product) {
        return product && product.url && product.title;
      }).slice(0, 8);

      document.querySelectorAll('[data-cart-recently-viewed]').forEach(function (container) {
        renderRecentlyViewedContainer(container, products);
      });
    }

    function initRecentlyViewedWheel() {
      document.querySelectorAll('[data-cart-recently-viewed-row]').forEach(function (row) {
        if (row.dataset.cartRecentWheelInitialized === 'true') return;
        row.dataset.cartRecentWheelInitialized = 'true';

        row.addEventListener('wheel', function (event) {
          var aside = getAside();
          var mobileCartPanel = row.closest('.mobile-cart-panel');
          var isDesktopCartOpen = aside && aside.classList.contains('is-active');
          var isMobileCartOpen = mobileCartPanel && mobileCartPanel.classList.contains('is-open');
          if (!isDesktopCartOpen && !isMobileCartOpen) return;

          var delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
          if (delta === 0) return;

          var maxScroll = row.scrollWidth - row.clientWidth;
          if (maxScroll <= 0) return;

          var canScrollLeft = delta < 0 && row.scrollLeft > 0;
          var canScrollRight = delta > 0 && row.scrollLeft < maxScroll;
          if (!canScrollLeft && !canScrollRight) return;

          event.preventDefault();
          row.scrollLeft = Math.max(0, Math.min(maxScroll, row.scrollLeft + delta));
        }, { passive: false });
      });
    }

    function syncRecentlyViewedProducts() {
      renderRecentlyViewedProducts();
      initRecentlyViewedWheel();
      initRecentlyViewedAddButtons();
    }

    window.syncCartRecentlyViewedProducts = syncRecentlyViewedProducts;

    function syncCartCount() {
      if (countFetching) return countFetching;

      countFetching = fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

          document.querySelectorAll('[data-cart-count]').forEach(function (countEl) {
            countEl.textContent = count;
            countEl.classList.toggle('hidden', count === 0);
          });
        })
        .finally(function () {
          countFetching = null;
        });

      return countFetching;
    }

    function afterPaint(callback) {
      requestAnimationFrame(function () {
        requestAnimationFrame(callback);
      });
    }

    function show() {
      var overlay = getOverlay();
      var aside = getAside();
      lockPageScroll();
      if (overlay) overlay.classList.add('is-active');
      if (aside) {
        syncRecentlyViewedProducts();
        aside.classList.add('is-active');
        aside.setAttribute('aria-hidden', 'false');
        var openedDispatched = false;
        var openedHandler = function (e) {
          if (e.target !== aside) return;
          if (e.propertyName !== 'opacity') return;
          aside.removeEventListener('transitionend', openedHandler);
          dispatchOpened();
        };
        var openedTimer = setTimeout(function () {
          openedDispatched = true;
          aside.removeEventListener('transitionend', openedHandler);
          document.dispatchEvent(new CustomEvent('cart:opened'));
        }, 350);
        function dispatchOpened() {
          if (openedDispatched) return;
          openedDispatched = true;
          clearTimeout(openedTimer);
          document.dispatchEvent(new CustomEvent('cart:opened'));
        }
        aside.addEventListener('transitionend', openedHandler);
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:opened'));
    }

    function refreshContent() {
      if (fetching) return fetching;
      var wasActive = getAside() && getAside().classList.contains('is-active');
      fetching = fetch('/?sections=cart-aside')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var wrapper = document.getElementById('shopify-section-cart-aside');
          if (wrapper && data['cart-aside']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-aside'];
            var inner = tmp.firstElementChild;
            if (inner) {
              wrapper.innerHTML = inner.innerHTML;
              syncRecentlyViewedProducts();
              if (wasActive) show();
            }
          }
          return syncCartCount();
        })
        .finally(function () { fetching = null; });
      return fetching;
    }

    function open(event) {
      if (event && event.detail && event.detail.refresh) {
        refreshContent()
          .then(function () {
            afterPaint(show);
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:open:error'));
          });
        return;
      }

      show();
      refreshContent().catch(function () {
        document.dispatchEvent(new CustomEvent('cart:open:error'));
      });
    }

    function close() {
      var overlay = getOverlay();
      var aside = getAside();
      if (overlay) overlay.classList.remove('is-active');
      if (aside) { aside.classList.remove('is-active'); aside.setAttribute('aria-hidden', 'true'); }
      unlockPageScroll();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) {
        e.preventDefault();
        open();
        return;
      }

      if (e.target.closest('[data-cart-close]') || e.target === getOverlay()) {
        close();
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      var dec = e.target.closest('[data-cart-decrement]');
      var inc = e.target.closest('[data-cart-increment]');

      if (removeBtn) {
        var key = removeBtn.dataset.cartRemove;
        removeBtn.innerHTML = '<span class="cart-spinner"></span>';
        removeBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
        return;
      }

      var btn = dec || inc;
      if (!btn) return;

      var key = btn.dataset.cartDecrement || btn.dataset.cartIncrement;
      var current = parseInt(btn.dataset.quantity, 10);
      var next = Math.max(0, current + (inc ? 1 : -1));

      var li = btn.closest('[data-cart-item]');
      if (li) {
        var qtyEl = li.querySelector('[data-cart-qty="' + key + '"]');
        if (qtyEl) qtyEl.innerHTML = '<span class="cart-spinner"></span>';
        li.querySelectorAll('[data-cart-decrement="' + key + '"], [data-cart-increment="' + key + '"]').forEach(function (b) {
          b.disabled = true;
        });
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next }),
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('cart:open', open);
    document.addEventListener('cart:refresh', function () {
      syncCartCount();
      refreshContent();
    });
    syncCartCount();
    syncRecentlyViewedProducts();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  function getCurrentProductHandle() {
    var currentProduct = document.querySelector('[data-product-page]');

    return currentProduct ? currentProduct.dataset.productHandle || '' : '';
  }

  function getRecentlyViewedProducts() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem('past-midnight:recent-products') || '[]');

      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  }

  function buildRecentCard(product) {
    var item = document.createElement('div');
    item.className = 'carousel-item carousel-item--revealed';

    var link = document.createElement('a');
    link.className = 'relative group bg-[#ECECEC] p-3 md:p-10 w-full aspect-3/4 overflow-hidden block product-card';
    link.href = product.url || '#';
    link.dataset.images = '[]';

    var imageWrap = document.createElement('div');
    imageWrap.className = 'image product-card__image absolute inset-0 overflow-hidden';

    var loader = document.createElement('div');
    loader.className = 'image__loader';
    loader.setAttribute('aria-hidden', 'true');

    var spinner = document.createElement('span');
    spinner.className = 'image__spinner';
    loader.appendChild(spinner);

    if (product.image) {
      var image = document.createElement('img');
      image.className = 'image__img product-card__main-img absolute inset-0 size-full object-cover object-center';
      image.src = product.image;
      image.alt = product.imageAlt || product.title || '';
      image.loading = 'lazy';
      image.addEventListener('load', function () {
        imageWrap.classList.add('image--loaded');
      });

      if (image.complete && image.naturalWidth > 0) {
        imageWrap.classList.add('image--loaded');
      }

      imageWrap.appendChild(loader);
      imageWrap.appendChild(image);
    } else {
      imageWrap.className += ' bg-black/5';
    }

    var content = document.createElement('div');
    content.className = 'absolute inset-0 flex flex-col justify-end p-3 md:p-4';

    var details = document.createElement('div');
    details.className = 'w-full flex items-end justify-between gap-4';

    var titleWrap = document.createElement('div');

    var title = document.createElement('p');
    title.className = 'text-xs text-(--color-text-dark)/50';
    title.textContent = product.title || '';

    var price = document.createElement('p');
    price.className = 'text-xs';
    price.textContent = product.price || '';

    titleWrap.appendChild(title);
    titleWrap.appendChild(price);
    details.appendChild(titleWrap);

    content.appendChild(details);
    link.appendChild(imageWrap);
    link.appendChild(content);
    item.appendChild(link);

    return item;
  }

  function revealCarouselItems(items) {
    items.forEach(function (item, index) {
      setTimeout(function () {
        item.classList.add('carousel-item--revealed');
      }, index * 200);
    });
  }

  function initCarouselSection(carousel) {
    if (carousel.dataset.carouselInitialized === 'true') return;
    carousel.dataset.carouselInitialized = 'true';

    var tabsEnabled = carousel.dataset.carouselRecentlyViewed === 'true';
    var panels = carousel.querySelectorAll('[data-carousel-panel]');
    var recentGrid = carousel.querySelector('[data-carousel-recent-grid]');
    var recentEmpty = carousel.querySelector('[data-carousel-recent-empty]');
    var tabs = carousel.querySelectorAll('[data-carousel-tab]');
    var recentRendered = false;
    var currentHandle = getCurrentProductHandle();

    function renderRecentlyViewed() {
      if (!recentGrid || recentRendered) return;

      var products = getRecentlyViewedProducts()
        .filter(function (product) {
          return product && product.handle && product.handle !== currentHandle;
        })
        .slice(0, 4);

      recentGrid.innerHTML = '';

      if (!products.length) {
        if (recentEmpty) recentEmpty.classList.remove('hidden');
        recentRendered = true;
        return;
      }

      if (recentEmpty) recentEmpty.classList.add('hidden');

      products.forEach(function (product) {
        recentGrid.appendChild(buildRecentCard(product));
      });

      if (window.initProductCards) {
        window.initProductCards(recentGrid);
      }

      recentRendered = true;
    }

    function setActiveTab(tabName) {
      if (!tabsEnabled) return;

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.carouselTab === tabName;
        tab.classList.toggle('border-black', isActive);
        tab.classList.toggle('border-transparent', !isActive);
        tab.classList.toggle('text-black/40', !isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('hidden', panel.dataset.carouselPanel !== tabName);
      });

      if (tabName === 'recently-viewed') {
        renderRecentlyViewed();
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(tab.dataset.carouselTab);
      });
    });

    if (tabs.length > 0) {
      setActiveTab('recommended');
    }

    var items = carousel.querySelectorAll('.carousel-item');

    if (document.body.classList.contains('intro-animations-disabled')) {
      items.forEach(function (item) {
        item.classList.add('carousel-item--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          revealCarouselItems(items);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(carousel);
  }

  function initCarouselSections(root) {
    var carousels = [];

    if (root && root.matches && root.matches('.carousel-section')) {
      carousels.push(root);
    }

    if (root && root.querySelectorAll) {
      carousels = carousels.concat(Array.prototype.slice.call(root.querySelectorAll('.carousel-section')));
    }

    carousels.forEach(function (carousel) {
      initCarouselSection(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCarouselSections(document);
    });
  } else {
    initCarouselSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCarouselSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-display"] && !Shopify.designMode) return;
  try {
    
  if (document.body.classList.contains('intro-animations-disabled')) {
    document.querySelectorAll('.display-panel').forEach(function (panel) {
      panel.classList.add('display-panel--revealed');
    });
  } else {
    document.querySelectorAll('.display-section').forEach(function (section) {
      var panels = section.querySelectorAll('.display-panel');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            panels.forEach(function (panel, index) {
              setTimeout(function () {
                panel.classList.add('display-panel--revealed');
              }, index * 200);
            });

            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initCollectionReveal(container) {
    if (document.body.classList.contains('intro-animations-disabled')) {
      container.querySelectorAll('.collection-item').forEach(function (item) {
        item.classList.add('collection-item--revealed');
      });
      return;
    }

    container.querySelectorAll('.collection-grid').forEach(function (grid) {
      // Theme editor reloads can re-run section scripts, so bind each grid once.
      if (grid.dataset.collectionRevealInitialized === 'true') return;
      grid.dataset.collectionRevealInitialized = 'true';

      var items = Array.prototype.slice.call(grid.querySelectorAll('.collection-item'));

      if (!items.length) return;

      // Older browsers should still show the collection even without reveal support.
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('collection-item--revealed');
        });
        return;
      }

      function revealItemsByRow() {
        // Sort by rendered position so the stagger follows the responsive grid rows.
        items
          .slice()
          .sort(function (firstItem, secondItem) {
            if (firstItem.offsetTop === secondItem.offsetTop) {
              return firstItem.offsetLeft - secondItem.offsetLeft;
            }

            return firstItem.offsetTop - secondItem.offsetTop;
          })
          .forEach(function (item, index) {
            setTimeout(function () {
              item.classList.add('collection-item--revealed');
            }, index * 80);
          });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            // Reveal the full grid once, then stop observing to avoid replaying.
            revealItemsByRow();
            observer.unobserve(grid);
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionReveal(document);
    });
  } else {
    initCollectionReveal(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionReveal(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filter-aside"]) return;
  try {
    
  (function () {
    function getOverlay() { return document.querySelector('[data-filter-overlay]'); }
    function getAside() { return document.querySelector('[data-filter-aside]'); }

    function show() {
      var overlay = getOverlay();
      var aside = getAside();
      if (overlay) overlay.classList.add('is-active');
      if (aside) { aside.classList.add('is-active'); aside.setAttribute('aria-hidden', 'false'); }
    }

    function open() {
      requestAnimationFrame(function () {
        requestAnimationFrame(show);
      });
    }

    function close() {
      var overlay = getOverlay();
      var aside = getAside();
      if (overlay) overlay.classList.remove('is-active');
      if (aside) { aside.classList.remove('is-active'); aside.setAttribute('aria-hidden', 'true'); }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-toggle]')) {
        e.preventDefault();
        open();
        return;
      }

      if (e.target.closest('[data-filter-close]') || e.target === getOverlay()) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('filters:open', open);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const announcementBars = document.querySelectorAll('.announcement-bar');
  if (announcementBars.length > 0) {
    window.addEventListener(
      'scroll',
      () => {
        announcementBars.forEach((bar) => {
          if (window.scrollY > 0) {
            bar.classList.add('is-hidden');
          } else {
            bar.classList.remove('is-hidden');
          }
        });
      },
      { passive: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cards-section').forEach(function (section) {
    var heading = section.querySelector('.cards-heading');
    var items = section.querySelectorAll('.card-item');

    if (!heading && !items.length) return;

    if (document.body.classList.contains('intro-animations-disabled')) {
      if (heading) heading.classList.add('cards-heading--revealed');
      items.forEach(function (item) {
        item.classList.add('card-item--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          if (heading) {
            setTimeout(function () {
              heading.classList.add('cards-heading--revealed');
            }, 0);
          }

          items.forEach(function (item, index) {
            setTimeout(function () {
              item.classList.add('card-item--revealed');
            }, 150 + index * 150);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.layout-contact-section').forEach(function (section) {
    var panels = section.querySelectorAll('.contact-panel');

    if (!panels.length) return;

    if (document.body.classList.contains('intro-animations-disabled')) {
      panels.forEach(function (panel) {
        panel.classList.add('contact-panel--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          panels.forEach(function (panel, index) {
            setTimeout(function () {
              panel.classList.add('contact-panel--revealed');
            }, index * 75);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.layout-faq-section').forEach(function (section) {
    var panels = section.querySelectorAll('.layout-faq-panel');

    if (!panels.length) return;

    if (document.body.classList.contains('intro-animations-disabled')) {
      panels.forEach(function (panel) {
        panel.classList.add('layout-faq-panel--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          panels.forEach(function (panel, index) {
            setTimeout(function () {
              panel.classList.add('layout-faq-panel--revealed');
            }, index * 150);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-hero"] && !Shopify.designMode) return;
  try {
    
  if (document.body.classList.contains('intro-animations-disabled')) {
    document.querySelectorAll('.hero-cta').forEach(function (cta) {
      cta.classList.add('hero-cta--revealed');
    });
  } else {
    document.querySelectorAll('.hero-cta').forEach(function (cta) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            cta.classList.add('hero-cta--revealed');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(cta);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-images"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.layout-images-section').forEach(function (section) {
    var panels = section.querySelectorAll('.layout-images-panel');

    if (document.body.classList.contains('intro-animations-disabled')) {
      panels.forEach(function (panel) {
        panel.classList.add('layout-images-panel--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          panels.forEach(function (panel, index) {
            setTimeout(function () {
              panel.classList.add('layout-images-panel--revealed');
            }, index * 200);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-info"] && !Shopify.designMode) return;
  try {
    
  if (document.body.classList.contains('intro-animations-disabled')) {
    document.querySelectorAll('.layout-info-panel').forEach(function (panel) {
      panel.classList.add('layout-info-panel--revealed');
    });
  } else {
    document.querySelectorAll('.layout-info-section').forEach(function (section) {
      var panels = section.querySelectorAll('.layout-info-panel');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            panels.forEach(function (panel, index) {
              setTimeout(function () {
                panel.classList.add('layout-info-panel--revealed');
              }, index * 200);
            });

            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-press"] && !Shopify.designMode) return;
  try {
    
  function initializePressSections(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('.press-section'));

    if (scope.matches && scope.matches('.press-section')) {
      sections.unshift(scope);
    }

    sections.forEach(function (section) {
      if (section.dataset.pressInitialized === 'true') return;

      var panels = section.querySelectorAll('.press-panel');
      var list = section.querySelector('.press-links__list');
      var baseImage = section.querySelector('.press-links__image--base');
      var overlayImage = section.querySelector('.press-links__image--overlay');
      var caption = section.querySelector('[data-press-caption-target]');
      var activeSrc = baseImage ? baseImage.getAttribute('src') : '';
      var requestId = 0;
      var animationsDisabled = document.body.classList.contains('intro-animations-disabled');
      var preloadedPressImages = [];

      if (!panels.length) return;

      section.dataset.pressInitialized = 'true';

      if (animationsDisabled) {
        panels.forEach(function (panel) {
          panel.classList.add('press-panel--revealed');
        });
      }

      function commitOverlay() {
        if (!baseImage || !overlayImage) return;

        baseImage.setAttribute('src', overlayImage.getAttribute('src'));
        activeSrc = baseImage.getAttribute('src') || '';
        overlayImage.style.transition = 'none';
        overlayImage.classList.remove('is-active');
        overlayImage.offsetHeight;
        overlayImage.style.transition = '';
      }

      function setCaption(text, alignment) {
        if (!caption) return;

        caption.textContent = text || '';
        caption.classList.toggle('hidden', !text);
        caption.classList.remove('press-links__caption--left', 'press-links__caption--center', 'press-links__caption--right');
        caption.classList.add('press-links__caption--' + (alignment || 'center'));
      }

      function setPreview(src, captionText, captionAlignment) {
        if (!baseImage || !overlayImage || !src) return;
        if (src === activeSrc) {
          setCaption(captionText, captionAlignment);
          return;
        }

        requestId += 1;
        var currentRequestId = requestId;
        var preload = new Image();

        preload.onload = function () {
          if (currentRequestId !== requestId) return;

          window.clearTimeout(overlayImage._pressImageTimer);

          if (overlayImage.classList.contains('is-active')) {
            baseImage.setAttribute('src', overlayImage.getAttribute('src'));
          }

          overlayImage.style.transition = 'none';
          overlayImage.classList.remove('is-active');
          overlayImage.setAttribute('src', src);
          overlayImage.offsetHeight;
          overlayImage.style.transition = '';
          overlayImage.classList.add('is-active');

          activeSrc = src;
          setCaption(captionText, captionAlignment);
          overlayImage._pressImageTimer = window.setTimeout(commitOverlay, 240);
        };

        preload.src = src;

        if (preload.complete) {
          preload.onload();
        }
      }

      if (list) {
        list.querySelectorAll('.press-link').forEach(function (link, index) {
          var src = link.getAttribute('data-press-image');
          var captionText = link.getAttribute('data-press-caption') || '';
          var captionAlignment = link.getAttribute('data-press-caption-alignment') || 'center';

          if (index === 0 && src && baseImage && overlayImage) {
            baseImage.setAttribute('src', src);
            overlayImage.setAttribute('src', src);
            activeSrc = src;
            setCaption(captionText, captionAlignment);
          }

          if (!src) return;

          var preload = new Image();
          preload.src = src;
          preloadedPressImages.push(preload);

          link.addEventListener('pointerenter', function () {
            setPreview(src, captionText, captionAlignment);
          });

          link.addEventListener('focus', function () {
            setPreview(src, captionText, captionAlignment);
          });
        });
      }

      if (animationsDisabled || !('IntersectionObserver' in window)) {
        panels.forEach(function (panel) {
          panel.classList.add('press-panel--revealed');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            panels.forEach(function (panel, index) {
              setTimeout(function () {
                panel.classList.add('press-panel--revealed');
              }, index * 200);
            });

            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(section);
    });
  }

  initializePressSections(document);

  document.addEventListener('DOMContentLoaded', function () {
    initializePressSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializePressSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.layout-text-section').forEach(function (section) {
    var panels = section.querySelectorAll('.layout-text-panel');

    if (document.body.classList.contains('intro-animations-disabled')) {
      panels.forEach(function (panel) {
        panel.classList.add('layout-text-panel--revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          panels.forEach(function (panel, index) {
            setTimeout(function () {
              panel.classList.add('layout-text-panel--revealed');
            }, index * 200);
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-timeline"] && !Shopify.designMode) return;
  try {
    
  function initializeTimelineSections(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('.layout-timeline-section'));

    if (scope.matches && scope.matches('.layout-timeline-section')) {
      sections.unshift(scope);
    }

    sections.forEach(function (section) {
      if (section.dataset.timelineInitialized === 'true') return;

      var entries = Array.prototype.slice.call(section.querySelectorAll('[data-timeline-entry]'));
      var track = section.querySelector('[data-timeline-track]');
      var fill = section.querySelector('[data-timeline-fill]');
      var detail = section.querySelector('.timeline-detail');
      var title = section.querySelector('[data-timeline-title]');
      var text = section.querySelector('[data-timeline-text]');
      var panels = section.querySelectorAll('.timeline-panel');
      var baseImage = section.querySelector('.timeline-image--base');
      var overlayImage = section.querySelector('.timeline-image--overlay');
      var activeImageSrc = baseImage ? baseImage.getAttribute('src') : '';
      var animationsDisabled = document.body.classList.contains('intro-animations-disabled');

      if (!entries.length || !track || !fill || !detail || !title || !text) return;

      section.dataset.timelineInitialized = 'true';

      if (animationsDisabled) {
        panels.forEach(function (panel) {
          panel.classList.add('timeline-panel--revealed');
        });
      }

      var swapTimer = null;
      var activeIndex = -1;

      function commitImageOverlay() {
        if (!baseImage || !overlayImage) return;

        baseImage.setAttribute('src', overlayImage.getAttribute('src'));
        activeImageSrc = baseImage.getAttribute('src') || '';
        overlayImage.style.transition = 'none';
        overlayImage.classList.remove('is-active');
        overlayImage.offsetHeight;
        overlayImage.style.transition = '';
      }

      function setPreviewImage(src) {
        if (!baseImage || !overlayImage || !src) return;
        if (src === activeImageSrc) return;

        window.clearTimeout(overlayImage._timelineImageTimer);

        if (overlayImage.classList.contains('is-active')) {
          baseImage.setAttribute('src', overlayImage.getAttribute('src'));
        }

        overlayImage.style.transition = 'none';
        overlayImage.classList.remove('is-active');
        overlayImage.setAttribute('src', src);
        overlayImage.offsetHeight;
        overlayImage.style.transition = '';
        overlayImage.classList.add('is-active');

        activeImageSrc = src;
        overlayImage._timelineImageTimer = window.setTimeout(commitImageOverlay, 240);
      }

      function updateFill(index) {
        var trackRect = track.getBoundingClientRect();
        var entry = entries[index];
        var label = entry && entry.querySelector('[data-timeline-label]');

        if (!entry || !trackRect.height) {
          return;
        }

        if (entries.length === 1 || index === entries.length - 1) {
          fill.style.height = trackRect.height + 'px';
          return;
        }

        var marker = label || entry;
        var markerRect = marker.getBoundingClientRect();
        var markerCenter = markerRect.top + markerRect.height / 2;
        var fillHeight = markerCenter - trackRect.top;

        fill.style.height = Math.max(0, Math.min(fillHeight, trackRect.height)) + 'px';
      }

      function setActive(index, immediate) {
        var entry = entries[index];

        if (!entry) return;
        if (index === activeIndex && !immediate) return;

        if (swapTimer) {
          window.clearTimeout(swapTimer);
        }

        activeIndex = index;

        entries.forEach(function (button, buttonIndex) {
          var isActive = buttonIndex === index;

          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updateFill(index);
        setPreviewImage(entry.dataset.image);

        if (immediate) {
          title.textContent = entry.dataset.title || '';
          text.textContent = entry.dataset.text || '';
          detail.classList.remove('is-swapping');
          return;
        }

        detail.classList.add('is-swapping');

        swapTimer = window.setTimeout(function () {
          title.textContent = entry.dataset.title || '';
          text.textContent = entry.dataset.text || '';
          detail.classList.remove('is-swapping');
        }, 180);
      }

      entries.forEach(function (button) {
        button.addEventListener('pointerenter', function () {
          setActive(Number(button.dataset.index), false);
        });

        button.addEventListener('mouseenter', function () {
          setActive(Number(button.dataset.index), false);
        });

        button.addEventListener('focus', function () {
          setActive(Number(button.dataset.index), false);
        });

        button.addEventListener('click', function () {
          setActive(Number(button.dataset.index), false);
        });
      });

      setActive(0, true);

      window.addEventListener('resize', function () {
        if (activeIndex < 0) return;

        updateFill(activeIndex);
      });

      if (!animationsDisabled) {
        var observer = new IntersectionObserver(
          function (observations) {
            observations.forEach(function (observation) {
              if (!observation.isIntersecting) return;

              panels.forEach(function (panel, index) {
                setTimeout(function () {
                  panel.classList.add('timeline-panel--revealed');
                }, index * 200);
              });

              observer.unobserve(observation.target);
            });
          },
          { threshold: 0.2 }
        );

        observer.observe(section);
      }
    });
  }

  initializeTimelineSections(document);

  document.addEventListener('DOMContentLoaded', function () {
    initializeTimelineSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeTimelineSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function persistRecentlyViewedProduct(root) {
    var productPage =
      root && root.matches && root.matches('[data-product-page]')
        ? root
        : root.querySelector('[data-product-page]');

    if (!productPage || !window.sessionStorage) return;

    var key = 'past-midnight:recent-products';
    var currentProduct = {
      handle: productPage.dataset.productHandle || '',
      url: productPage.dataset.productUrl || '',
      title: productPage.dataset.productTitle || '',
      price: productPage.dataset.productPrice || '',
      variantId: productPage.dataset.productVariantId || '',
      image: productPage.dataset.productImage || '',
      imageAlt: productPage.dataset.productImageAlt || ''
    };

    if (!currentProduct.handle || !currentProduct.url) return;

    try {
      var recentProducts = JSON.parse(window.sessionStorage.getItem(key) || '[]');

      if (!Array.isArray(recentProducts)) recentProducts = [];

      recentProducts = recentProducts.filter(function (product) {
        return product && product.handle !== currentProduct.handle;
      });

      recentProducts.unshift(currentProduct);
      window.sessionStorage.setItem(key, JSON.stringify(recentProducts.slice(0, 20)));
    } catch (error) {
      // Ignore storage errors in restricted contexts.
    }
  }

  function initJudgeMeRating(container) {
    var summary = container.querySelector('[data-product-rating-summary]');
    var value = summary && summary.querySelector('[data-product-rating-value]');
    var widget = document.querySelector('#judgeme_product_reviews');

    if (!summary || !value || !widget) return;

    var lastText = (summary.dataset.initialRating || '').trim();
    var settled = false;
    var observer = null;

    function updateFromWidget() {
      if (settled) return true;

      var textNode =
        widget.querySelector('.jm-average-rating-display .jm-text:first-child') ||
        widget.querySelector('.jm-average-rating-display');

      if (!textNode) return false;

      var text = (textNode.textContent || '').trim();
      var match = text.match(/(\d+(?:\.\d+)?)/);

      if (!match) return false;

      var rating = match[1];
      if (rating === lastText) {
        settled = true;
        summary.dataset.ratingState = 'loaded';
        value.classList.remove('text-black/40');
        value.classList.add('text-black/60');
        summary.classList.remove('hidden');
        if (observer) observer.disconnect();
        return true;
      }

      settled = true;
      lastText = rating;
      value.textContent = rating;
      summary.dataset.ratingState = 'loaded';
      value.classList.remove('text-black/40');
      value.classList.add('text-black/60');
      summary.classList.remove('hidden');
      if (observer) observer.disconnect();
      return true;
    }

    if (updateFromWidget()) return;

    observer = new MutationObserver(function () {
      updateFromWidget();
    });

    observer.observe(widget, { childList: true, subtree: true, characterData: true });
  }

  function initReviewJump(container) {
    var summary = container.querySelector('[data-product-rating-summary]');

    if (!summary) return;

    summary.addEventListener('click', function (event) {
      var target = document.querySelector('#judgeme_product_reviews');

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initProductPage(container) {
    persistRecentlyViewedProduct(container);
    initJudgeMeRating(container);
    initReviewJump(container);

    // Mobile product media carousel
    container.querySelectorAll('[data-product-media]').forEach(function (media) {
      if (media.dataset.productMediaInitialized === 'true') return;
      media.dataset.productMediaInitialized = 'true';

      var track = media.querySelector('[data-product-media-track]');
      var progress = media.querySelector('[data-product-media-progress]');
      var slides = media.querySelectorAll('[data-product-media-slide]');

      if (!track || !progress || slides.length < 2) return;

      function updateProgress() {
        var slideWidth = track.clientWidth;

        if (!slideWidth) return;

        var index = Math.round(track.scrollLeft / slideWidth);
        var boundedIndex = Math.max(0, Math.min(index, slides.length - 1));
        var value = (boundedIndex + 1) / slides.length;

        progress.style.transform = 'scaleX(' + value + ')';
      }

      updateProgress();
      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
    });

    // Linked color variant cards
    container.querySelectorAll('[data-product-color-group]').forEach(function (group) {
      if (group.dataset.productColorInitialized === 'true') return;
      group.dataset.productColorInitialized = 'true';

      var label = group.querySelector('[data-product-color-label]');
      var cards = group.querySelectorAll('[data-product-color-card]');
      var defaultColor = group.dataset.defaultColor || '';

      if (!label) return;

      function setColor(color) {
        label.textContent = color || defaultColor;
      }

      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          setColor(card.dataset.productColor);
        });

        card.addEventListener('focus', function () {
          setColor(card.dataset.productColor);
        });
      });

      group.addEventListener('mouseleave', function () {
        setColor(defaultColor);
      });

      group.addEventListener('focusout', function (event) {
        if (group.contains(event.relatedTarget)) return;

        setColor(defaultColor);
      });
    });

    // Product detail drawers
    container.querySelectorAll('.product-page__drawer').forEach(function (drawer) {
      if (drawer.dataset.productDrawerInitialized === 'true') return;
      drawer.dataset.productDrawerInitialized = 'true';

      var summary = drawer.querySelector('summary');
      var panel = drawer.querySelector('.product-page__drawer-panel');
      var icon = drawer.querySelector('.product-page__drawer-icon');

      if (!summary || !panel) return;

      function setIcon() {
        if (icon) icon.classList.toggle('rotate-45', drawer.open);
      }

      function setInitialPanelState() {
        panel.style.height = drawer.open ? 'auto' : '0px';
        panel.style.opacity = drawer.open ? '1' : '0';
        panel.style.overflow = drawer.open ? 'visible' : 'hidden';
      }

      function openDrawer() {
        drawer.open = true;
        setIcon();

        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.style.overflow = 'hidden';
        panel.offsetHeight;
        panel.style.transition = 'height 320ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease';
        panel.style.height = panel.scrollHeight + 'px';
        panel.style.opacity = '1';

        panel.addEventListener('transitionend', function onOpenEnd(event) {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onOpenEnd);
          panel.style.height = 'auto';
          panel.style.overflow = 'visible';
          panel.style.transition = '';
        });
      }

      function closeDrawer() {
        if (icon) icon.classList.remove('rotate-45');
        panel.style.height = panel.scrollHeight + 'px';
        panel.style.opacity = '1';
        panel.style.overflow = 'hidden';
        panel.offsetHeight;
        panel.style.transition = 'height 260ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms ease';
        panel.style.height = '0px';
        panel.style.opacity = '0';

        panel.addEventListener('transitionend', function onCloseEnd(event) {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onCloseEnd);
          drawer.open = false;
          setIcon();
          panel.style.transition = '';
        });
      }

      setIcon();
      setInitialPanelState();

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (drawer.open) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    });

    // Mobile fixed add-to-cart bar
    // Form discovery
    container.querySelectorAll('.product-page__form').forEach(function (form) {
      if (form.dataset.productPageInitialized === 'true') return;
      form.dataset.productPageInitialized = 'true';

      var formId = form.id || '';
      var select = form.querySelector('.product-page__select');
      var submit = form.querySelector('.product-page__submit');
      var formKey = submit ? submit.dataset.productPageSubmitButton || formId : formId;
      var submitButtons = formKey ? container.querySelectorAll('[data-product-page-submit-button="' + formKey + '"]') : [];
      var price = formKey ? container.querySelectorAll('[data-product-page-price="' + formKey + '"]') : [];
      var submitLabels = formKey ? container.querySelectorAll('[data-product-page-submit-label="' + formKey + '"]') : [];
      var mobileSubmitBar = formKey
        ? container.querySelector('[data-product-mobile-submit-bar-for="' + formKey + '"]')
        : null;
      var mobileSubmitBarVisible = false;
      var installmentPrices = form.querySelectorAll(
        '[data-product-page-installment-price], [data-product-page-installment-price-mobile]'
      );
      var preorderEstimate = form.querySelector('[data-product-page-preorder-estimate]');

      if (!submit) return;

      var isPreorder = submit.dataset.productPagePreorder === 'true';
      var preorderModal = null;
      var preorderConfirm = null;
      var isPreorderConfirmed = false;
      var previousActiveElement = null;

      // Loading and availability state
      function setLoading(isLoading) {
        submitButtons.forEach(function (button) {
          button.classList.toggle('is-loading', isLoading);
          button.disabled = isLoading || !isSelectedVariantAvailable();
          button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        });
        submit.disabled = isLoading || !isSelectedVariantAvailable();

        submitLabels.forEach(function (label) {
          if (isLoading) {
            label.innerHTML = '<span class="product-page__submit-spinner"></span>';
          } else {
            label.textContent = getSubmitLabel(isSelectedVariantAvailable());
          }
        });
      }

      function isSelectedVariantAvailable() {
        if (!select) return submit.dataset.productPageAvailable === 'true';

        var option = select.options[select.selectedIndex];

        return option.dataset.available === 'true' || option.dataset.preorder === 'true';
      }

      function isSelectedVariantPreorder() {
        if (!select) return submit.dataset.productPagePreorder === 'true';

        var option = select.options[select.selectedIndex];

        return option.dataset.preorder === 'true';
      }

      function getSubmitLabel(available) {
        if (!available) return 'Sold out';

        return isSelectedVariantPreorder() ? 'Preorder' : 'Add to cart';
      }

      function openPreorderModal() {
        preorderModal = document.querySelector('[data-product-preorder-modal]');
        if (!preorderModal) return;

        bindPreorderModal();
        previousActiveElement = document.activeElement;
        preorderModal.classList.add('is-active');
        preorderModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (preorderConfirm) preorderConfirm.focus();
      }

      function closePreorderModal() {
        preorderModal = document.querySelector('[data-product-preorder-modal]');
        if (!preorderModal) return;

        preorderModal.classList.remove('is-active');
        preorderModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus();
        }
      }

      function addToCart() {
        setLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
          })
          .then(function () {
            isPreorderConfirmed = false;
          });
      }

      // Variant UI updates
      function updateSelectedVariant() {
        if (!select) return;
        var option = select.options[select.selectedIndex];
        var available = isSelectedVariantAvailable();
        var preorder = isSelectedVariantPreorder();

        isPreorder = preorder;
        submit.dataset.productPagePreorder = preorder ? 'true' : 'false';

        price.forEach(function (priceElement) {
          priceElement.textContent = option.dataset.price || priceElement.textContent;
        });
        installmentPrices.forEach(function (installmentPrice) {
          installmentPrice.textContent = option.dataset.installmentPrice || installmentPrice.textContent;
        });
        submitLabels.forEach(function (label) {
          label.textContent = preorder ? 'Preorder' : getSubmitLabel(available);
        });
        submitButtons.forEach(function (button) {
          button.disabled = !available;
          button.dataset.productPagePreorder = preorder ? 'true' : 'false';
        });
        if (preorderEstimate) preorderEstimate.classList.toggle('hidden', !preorder);
      }

      if (select) {
        select.addEventListener('change', updateSelectedVariant);
      }

      // Cart aside events
      document.addEventListener('cart:open:error', function () {
        setLoading(false);
      });

      document.addEventListener('cart:opened', function () {
        setLoading(false);
      });

      if (mobileSubmitBar) {
        mobileSubmitBar.dataset.productSubmitBarInitialized = 'true';
        mobileSubmitBar.querySelectorAll('button[type="submit"]').forEach(function (button) {
          if (formId) button.setAttribute('form', formId);

          button.addEventListener('click', function (event) {
            event.preventDefault();

            if (button.disabled || submit.disabled) return;

            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(submit);
            } else {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          });
        });

        function setMobileSubmitBarVisibility(isVisible) {
          mobileSubmitBarVisible = isVisible;
          mobileSubmitBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          mobileSubmitBar.classList.toggle('is-visible', isVisible);
        }

        function updateMobileSubmitBarVisibility() {
          if (window.innerWidth >= 768) {
            setMobileSubmitBarVisibility(false);
            return;
          }

          var shouldShow = submit.getBoundingClientRect().bottom <= 0;

          if (shouldShow === mobileSubmitBarVisible) return;

          setMobileSubmitBarVisibility(shouldShow);
        }

        updateMobileSubmitBarVisibility();
        window.addEventListener('scroll', updateMobileSubmitBarVisibility, { passive: true });

        window.addEventListener('resize', function () {
          updateMobileSubmitBarVisibility();
        });
      }

      function bindPreorderModal() {
        preorderModal = document.querySelector('[data-product-preorder-modal]');
        if (!preorderModal || preorderModal.dataset.productPreorderInitialized === 'true') return;

        preorderModal.dataset.productPreorderInitialized = 'true';
        preorderConfirm = preorderModal.querySelector('[data-product-preorder-confirm]');
        var preorderCancelButtons = preorderModal.querySelectorAll('[data-product-preorder-cancel]');

        preorderCancelButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            isPreorderConfirmed = false;
            closePreorderModal();
          });
        });

        preorderModal.addEventListener('click', function (event) {
          if (event.target !== preorderModal) return;

          isPreorderConfirmed = false;
          closePreorderModal();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          if (!preorderModal.classList.contains('is-active')) return;

          isPreorderConfirmed = false;
          closePreorderModal();
        });

        if (preorderConfirm) {
          preorderConfirm.addEventListener('click', function () {
            isPreorderConfirmed = true;
            closePreorderModal();
            addToCart();
          });
        }
      }

      // AJAX add to cart
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submit.classList.contains('is-loading') || submit.disabled) return;

        if (isPreorder && !isPreorderConfirmed) {
          preorderModal = document.querySelector('[data-product-preorder-modal]');
          if (preorderModal) {
            openPreorderModal();
          } else {
            addToCart();
          }
          return;
        }

        addToCart();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductPage(document);
    });
  } else {
    initProductPage(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductPage(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-aside"]) return;
  try {
    
  (function () {
    var aside = document.getElementById('search-aside');
    if (!aside) return;

    var form = aside.querySelector('.search-aside__form');
    var input = aside.querySelector('#desktop-search-input');
    var resultsContainer = aside.querySelector('.search-aside__results');
    var closeBtn = aside.querySelector('[data-search-close]');
    var overlay = document.querySelector('[data-search-overlay]');
    var headerGroup = document.querySelector('.header-group');
    var popularSpacer = aside.querySelector('.search-aside__popular-spacer');
    var debounceTimer = null;
    var abortController = null;
    var previousActiveElement = null;
    var closingTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    function setTriggersOpen(isOpen) {
      document.querySelectorAll('[data-search-toggle]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function moveAsideIntoHeader() {
      if (!headerGroup || aside.parentElement === headerGroup) return;

      var searchSlot = headerGroup.querySelector('[data-header-search-slot]');
      if (searchSlot) {
        searchSlot.appendChild(aside);
        return;
      }

      var megamenu = headerGroup.querySelector('.megamenu');
      if (megamenu && megamenu.nextSibling) {
        headerGroup.insertBefore(aside, megamenu.nextSibling);
      } else {
        headerGroup.appendChild(aside);
      }
    }

    function closeMegamenu() {
      if (!headerGroup) return;

      var megamenu = headerGroup.querySelector('.megamenu');
      if (megamenu) megamenu.classList.remove('is-active');

      headerGroup.querySelectorAll('[data-megamenu-trigger]').forEach(function (trigger) {
        trigger.classList.remove('is-active');
      });

      if (megamenu) {
        megamenu.querySelectorAll('[data-megamenu-panel]').forEach(function (panel) {
          panel.classList.remove('is-active');
        });
      }
    }

    function syncPopularSpacer() {
      if (!form || !popularSpacer) return;
      popularSpacer.style.height = form.offsetHeight + 'px';
    }

    function clearResults() {
      resultsContainer.innerHTML = '<div class="search-aside__results-inner" data-search-results-inner></div>';
    }

    function renderSpinner() {
      resultsContainer.innerHTML =
        '<div class="search-aside__results-inner" data-search-results-inner>' +
        '<div class="search-aside__loading">' +
        '<svg class="animate-spin" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="rgba(0,0,0,0.15)" stroke-width="2"/><path d="M14.5 8a6.5 6.5 0 00-6.5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</div>' +
        '</div>';
    }

    function initRenderedImages() {
      resultsContainer.querySelectorAll('.image').forEach(function (wrapper) {
        if (wrapper.dataset.searchImageInitialized === 'true') return;
        wrapper.dataset.searchImageInitialized = 'true';

        var img = wrapper.querySelector('.image__img');
        if (!img) return;

        function markLoaded() {
          wrapper.classList.add('image--loaded');
        }

        if (img.complete && img.naturalWidth > 0) {
          markLoaded();
        } else {
          img.addEventListener('load', markLoaded, { once: true });
          img.addEventListener('error', markLoaded, { once: true });
        }
      });
    }

    function initCarouselWheel() {
      resultsContainer.querySelectorAll('.search-aside__row').forEach(function (row) {
        if (row.dataset.searchWheelInitialized === 'true') return;
        row.dataset.searchWheelInitialized = 'true';

        row.addEventListener('wheel', function (event) {
          if (!aside.classList.contains('is-open')) return;

          var delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
          if (delta === 0) return;

          var maxScroll = row.scrollWidth - row.clientWidth;
          if (maxScroll <= 0) return;

          var nextScroll = row.scrollLeft + delta;
          var canScrollLeft = delta < 0 && row.scrollLeft > 0;
          var canScrollRight = delta > 0 && row.scrollLeft < maxScroll;

          if (!canScrollLeft && !canScrollRight) return;

          event.preventDefault();
          row.scrollLeft = Math.max(0, Math.min(maxScroll, nextScroll));
        }, { passive: false });
      });
    }

    function initRenderedProductCards() {
      if (window.initProductCards) {
        window.initProductCards(resultsContainer);
      }

      initRenderedImages();
      initCarouselWheel();

      resultsContainer.querySelectorAll('.product-card').forEach(function (card) {
        if (card.dataset.productCardInitialized === 'true') return;
        if (card.dataset.searchCardInitialized === 'true') return;
        card.dataset.searchCardInitialized = 'true';

        var images = JSON.parse(card.dataset.images || '[]');
        var container = card.querySelector('.product-card__image');
        var img = container && container.querySelector('img');
        var currentIndex = 0;

        if (img) img.classList.add('product-card__main-img');
        if (!img || images.length <= 1) return;

        function setImage(index) {
          currentIndex = index;
          img.src = images[currentIndex];
        }

        var prev = card.querySelector('.product-card__prev');
        var next = card.querySelector('.product-card__next');

        if (prev) {
          prev.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            setImage((currentIndex - 1 + images.length) % images.length);
          });
        }

        if (next) {
          next.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            setImage((currentIndex + 1) % images.length);
          });
        }

        card.addEventListener('mouseleave', function () {
          if (currentIndex !== 0) setImage(0);
        });
      });

      resultsContainer.querySelectorAll('.product-card__add-btn').forEach(function (btn) {
        if (btn.dataset.searchAddInitialized === 'true') return;
        if (btn.dataset.productCardAddInitialized === 'true') return;
        btn.dataset.searchAddInitialized = 'true';

        function setLoading(isLoading) {
          btn.classList.toggle('is-loading', isLoading);
          btn.disabled = isLoading;
          btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        }

        document.addEventListener('cart:open:error', function () {
          setLoading(false);
        });

        document.addEventListener('cart:opened', function () {
          setLoading(false);
        });

        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var variantId = btn.dataset.variantId;
          if (!variantId || btn.classList.contains('is-loading')) return;

          setLoading(true);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Cart add failed');
              return response.json();
            })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
            });
        });
      });
    }

    function renderSectionResults(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;

      var nextResults = tmp.querySelector('[data-search-results-inner]');
      if (!nextResults) {
        clearResults();
        return;
      }

      resultsContainer.innerHTML = nextResults.innerHTML;
      initRenderedProductCards();
    }

    function debounce(fn, delay) {
      return function () {
        var args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { fn.apply(null, args); }, delay);
      };
    }

    var performSearch = debounce(function (query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var searchPageUrl = form ? form.getAttribute('action') : '/search';
      var url = searchPageUrl + '?q=' + encodeURIComponent(query) + '&type=product&sections=search-aside';

      renderSpinner();

      fetch(url, {
        signal: abortController.signal
      })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderSectionResults(data['search-aside'] || ''); })
        .catch(function (err) {
          if (err.name !== 'AbortError') clearResults();
        });
    }, 300);

    function openSearch() {
      if (!isDesktop()) return;
      moveAsideIntoHeader();
      previousActiveElement = document.activeElement;
      closeMegamenu();
      if (headerGroup) {
        headerGroup.classList.add('is-active', 'is-search-active');
      } else if (overlay) {
        overlay.classList.add('is-active');
      }
      clearTimeout(closingTimer);
      aside.classList.remove('is-closing');
      aside.classList.add('is-open');
      aside.setAttribute('aria-hidden', 'false');
      setTriggersOpen(true);
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        syncPopularSpacer();
        if (input) input.focus();
      });
    }

    function closeSearch() {
      if (overlay) overlay.classList.remove('is-active');
      clearTimeout(closingTimer);
      aside.classList.add('is-closing');
      aside.classList.remove('is-open');
      aside.setAttribute('aria-hidden', 'true');
      if (headerGroup) {
        headerGroup.classList.remove('is-search-active');
        if (!headerGroup.querySelector('.megamenu.is-active')) {
          headerGroup.classList.remove('is-active');
        }
      }
      setTriggersOpen(false);
      document.body.style.overflow = '';
      clearResults();
      if (input) input.value = '';
      if (abortController) abortController.abort();

      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }

      closingTimer = setTimeout(function () {
        aside.classList.remove('is-closing');
      }, 300);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-search-toggle]');
      if (!trigger || !isDesktop()) return;

      event.preventDefault();
      if (aside.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    }, true);

    if (headerGroup) {
      headerGroup.addEventListener('mouseleave', function () {
        if (aside.classList.contains('is-open')) closeSearch();
      });
    }

    document.addEventListener('search:close', function () {
      if (aside.classList.contains('is-open')) closeSearch();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeSearch();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeSearch();
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        var query = input.value.trim();

        if (query.length < 2) {
          clearResults();
          if (abortController) abortController.abort();
          return;
        }

        performSearch(query);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && aside.classList.contains('is-open')) {
        closeSearch();
      }
    });

    window.addEventListener('resize', function () {
      if (!isDesktop() && aside.classList.contains('is-open')) {
        closeSearch();
        return;
      }

      syncPopularSpacer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
